import type { ResourceEndpoints } from '../core'

export const projectsEndpoints = {
  collection: '/api/v1/projects',
  item: (id: string) => `/api/v1/projects/${encodeURIComponent(id)}`,
} satisfies ResourceEndpoints
